import "./header";
import "./cta-form";
import "./contacts";
import "./faq";
import "./scroll-to-top";
import mobileMenu from "./mobile-menu";

document.addEventListener("DOMContentLoaded", () => {
    mobileMenu();
});